// site-header.js — sticky scroll state, dropdowns, and mobile off-canvas menu.

const SiteHeader = {
	onReady() {
		const header = document.querySelector('.ax-header');

		if (!header) {
			return;
		}

		const offset =
			parseInt(header.getAttribute('data-sticky-offset'), 10) || 40;

		function updateScrolledState() {
			if (window.scrollY > offset) {
				header.classList.add('is-scrolled');
			} else {
				header.classList.remove('is-scrolled');
			}
		}

		updateScrolledState();

		window.addEventListener('scroll', updateScrolledState, {
			passive: true,
		});

		const toggle = header.querySelector('.ax-header__toggle');
		const nav = header.querySelector('.ax-header__nav');

		if (toggle && nav) {
			toggle.addEventListener('click', () => {
				const isOpen = header.classList.toggle('is-open');

				toggle.setAttribute(
					'aria-expanded',
					isOpen ? 'true' : 'false'
				);

				document.body.classList.toggle(
					'ax-header-open',
					isOpen
				);
			});
		}

		// Accordion dropdowns on touch/mobile.
		// Menu text navigates normally.
		// Only the caret opens/closes the submenu.

		if (window.axHeaderArrowHandler) {
			document.removeEventListener(
				'click',
				window.axHeaderArrowHandler,
				true
			);

			window.axHeaderArrowHandler = null;
		}

		function openSubmenu(menuItem) {
			const submenu = menuItem.querySelector(
				':scope > .ax-header__submenu'
			);

			if (!submenu) {
				return;
			}

			submenu.classList.remove('ax-closing');

			const currentHeight =
				submenu.getBoundingClientRect().height;

			submenu.style.height = 'auto';

			const targetHeight = submenu.scrollHeight;

			submenu.style.height = `${currentHeight}px`;

			submenu.offsetHeight;

			requestAnimationFrame(() => {
				submenu.style.height = `${targetHeight}px`;
			});

			const onEnd = (event) => {
				if (event.propertyName !== 'height') {
					return;
				}

				if (!menuItem.classList.contains('is-expanded')) {
					return;
				}

				submenu.style.height = 'auto';

				submenu.removeEventListener(
					'transitionend',
					onEnd
				);
			};

			submenu.addEventListener(
				'transitionend',
				onEnd
			);
		}

		function closeSubmenu(menuItem) {
			const submenu = menuItem.querySelector(
				':scope > .ax-header__submenu'
			);

			if (!submenu) {
				return;
			}

			submenu.classList.add('ax-closing');

			const currentHeight =
				submenu.getBoundingClientRect().height;

			submenu.style.height = `${currentHeight}px`;

			submenu.offsetHeight;

			requestAnimationFrame(() => {
				submenu.style.height = '0px';
			});

			const onEnd = (event) => {
				if (event.propertyName !== 'height') {
					return;
				}

				if (menuItem.classList.contains('is-expanded')) {
					return;
				}

				submenu.classList.remove('ax-closing');

				submenu.style.height = '0px';

				submenu.removeEventListener(
					'transitionend',
					onEnd
				);
			};

			submenu.addEventListener(
				'transitionend',
				onEnd
			);
		}
		
		function toggleMenuItem(parentItem) {
			const isOpening = !parentItem.classList.contains('is-expanded');

			parentItem.classList.toggle('is-expanded', isOpening);

			if (isOpening) {
				openSubmenu(parentItem);
			} else {
				closeSubmenu(parentItem);
			}
		}
		window.axHeaderArrowHandler = function (event) {
			const arrow = event.target.closest(
				'.ax-header__caret'
			);

			if (!arrow) {
				return;
			}

			if (window.innerWidth > 991) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();

			const parentItem = arrow.closest(
				'li.has-children'
			);

			if (!parentItem) {
				return;
			}

			toggleMenuItem(parentItem);
		};

		document.addEventListener(
			'click',
			window.axHeaderArrowHandler,
			true
		);
		if (window.axHeaderLinkHandler) {
			document.removeEventListener(
				'click',
				window.axHeaderLinkHandler,
				true
			);

			window.axHeaderLinkHandler = null;
		}

		const DOUBLE_CLICK_MS = 400;
		let lastLinkClick = { el: null, time: 0 };

		window.axHeaderLinkHandler = function (event) {
			if (window.innerWidth > 991) {
				return;
			}

			const link = event.target.closest(
				'.ax-header__menu > li.has-children > a'
			);

			if (!link) {
				return;
			}

			const now = Date.now();
			const isDoubleClick =
				lastLinkClick.el === link &&
				now - lastLinkClick.time < DOUBLE_CLICK_MS;

			if (isDoubleClick) {
				// Second click: reset state and let the link navigate.
				lastLinkClick = { el: null, time: 0 };
				return;
			}

			// First click: open/close the dropdown instead of navigating.
			event.preventDefault();
			event.stopPropagation();

			lastLinkClick = { el: link, time: now };

			const parentItem = link.closest('li.has-children');

			if (!parentItem) {
				return;
			}

			toggleMenuItem(parentItem);
		};

		document.addEventListener(
			'click',
			window.axHeaderLinkHandler,
			true
		);
		// Initialize any submenu already marked as expanded.
		header
			.querySelectorAll(
				'.has-children.is-expanded > .ax-header__submenu'
			)
			.forEach((submenu) => {
				submenu.style.height = 'auto';
				submenu.classList.remove('ax-closing');
			});

		// Close the off-canvas menu when the viewport grows back to desktop.
		window.addEventListener('resize', () => {
			if (
				window.innerWidth > 991 &&
				header.classList.contains('is-open')
			) {
				header.classList.remove('is-open');

				document.body.classList.remove(
					'ax-header-open'
				);

				if (toggle) {
					toggle.setAttribute(
						'aria-expanded',
						'false'
					);
				}
			}
		});
	},
};

export default SiteHeader;
